exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4aba53ce] .el-radio .el-radio__label {\n  font-size: 12px !important;\n}\n.tipsBox[data-v-4aba53ce] {\n  margin: 0 0 10px 90px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 13px;\n  color: #9f9f9f;\n}\n.tipsBox span[data-v-4aba53ce] {\n  margin-left: 5px;\n}", ""]);

// exports
